/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import Group from 'material/group/group';
import Field from 'material/form/field/field_container';
import Button from 'material/ctas/button/button_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/codeselector/codeselector_styles';



/* ========== ~~~~~~~~~~ CODE SELECTOR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const CodeSelector = (props) => {
    const handleFieldFocus = (e) => {
        e.target.select();
        document.execCommand('copy');
    };
    const handleButtonClick = (e) => {
        const codeField = e.target.closest('.group').querySelector('input');
        codeField.select();
        document.execCommand('copy');
    };
    const _renderCodePlacement =() => {
        switch(props.type) {
            case 'websitecode':
                return (
                    <div className={`codeselector ${props.classes.codeselector}`}>
                        <div className={`codepiece`}>
                            <p><span className={`highlight`}>1.</span> Place the following code right after the <span className={`highlight`}>{`<head>`}</span> tag in your HTML source code.</p>
                            <Group>
                                <Field type={`text`} name={`code`} handleFocus={handleFieldFocus} readOnly={true} value={props.headerCode} />
                                <Button type={`custom`} handleClick={handleButtonClick} variant={`primary`} name={`copy`} text={`COPY`} />
                            </Group>
                        </div>
                        <div className={`codepiece`}>
                            <p><span className={`highlight`}>2.</span> Place the following code inside of the <span className={`highlight`}>{`<body>`}</span> tag in your HTML source code.</p>
                            <Group>
                                <Field type={`text`} name={`code`} handleFocus={handleFieldFocus} readOnly={true} value={props.bodyCode} />
                                <Button type={`custom`} handleClick={handleButtonClick} variant={`primary`} name={`copy`} text={`COPY`} />
                            </Group>
                        </div>
                    </div>
                );
            case 'dfp':
            default:
                return(
                    <div className={`codeselector ${props.classes.codeselector}`}>
                        <div className={`codepiece`}>
                            <p>Use this code to install your Insticator Embed inside your DFP server.</p>
                            <p>Please make sure <span className={`highlight`}>Serve into a SafeFrame</span> option is <b>UNCHECKED</b> in your DFP creative.</p>
                            <p><small>*it is checked by default, so you will need to manually uncheck it.</small></p>
                            <Group>
                                <Field type={`text`} name={`code`} handleFocus={handleFieldFocus} readOnly={true} value={props.headerCode + props.bodyCode} />
                                <Button type={`custom`} handleClick={handleButtonClick} variant={`primary`} name={`copy`} text={`COPY`} />
                            </Group>
                        </div>
                    </div>
                )
        }
    };
    return(
        _renderCodePlacement()
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(CodeSelector);
